import { useMutation } from "@tanstack/react-query";
import { unitDelete } from "common/api/citajteo/dl_unit/citajteo_unit";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUnitDeleteParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
  errorHandle?: Function;
};

export const useUnitDelete = (hookParams?: UseUnitDeleteParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: unitDeleteMutate } = useMutation({
    mutationFn: async (id: string) => {
      const response = await unitDelete(id);

      if (!response) {
        throw new Error("unitDelete failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { unitDeleteMutate };
};
